import React, { useEffect, useRef } from 'react';

function DemoModal({ onClose }) {
  const videoRef = useRef(null);

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70"
      onClick={onClose}
    >
      <div
        className="relative bg-black rounded-xl shadow-2xl overflow-hidden"
        style={{ width: '90vw', maxWidth: '1100px' }}
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 py-3 bg-gray-900">
          <span className="text-white font-semibold text-sm">Demo — Track My Day</span>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition text-lg font-bold leading-none"
            aria-label="Sluiten"
          >
            ✕
          </button>
        </div>
        <video
          ref={videoRef}
          src="/demo.mp4?v=4"
          controls
          autoPlay
          className="w-full"
          style={{ display: 'block', maxHeight: '75vh' }}
        />
      </div>
    </div>
  );
}

export default DemoModal;
